// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CDEcCAjr7lz0l93Ms7OA {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #eee;
}
.tgrZIcUAG7NkqnVRm634 {
  width: 300px;
  margin-left: 20px;
}
.NdN4SqtcKR3B_0XkekgX {
  background-color: #fff;
  position: relative;
}
.NdN4SqtcKR3B_0XkekgX img {
  max-width: 100%;
  max-height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/admin-pages/Equipments/Item/GraphDesign/image.module.less"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAAF;AAGA;EACE,YAAA;EACA,iBAAA;AADF;AAIA;EACE,sBAAA;EACA,kBAAA;AAFF;AAAA;EAKI,eAAA;EACA,gBAAA;AAFJ","sourcesContent":["\n.container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #eee;\n}\n\n.imageControls {\n  width: 300px;\n  margin-left: 20px;\n}\n\n.image {\n  background-color: #fff;\n  position: relative;\n  \n  img {\n    max-width: 100%;\n    max-height: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CDEcCAjr7lz0l93Ms7OA`,
	"imageControls": `tgrZIcUAG7NkqnVRm634`,
	"image": `NdN4SqtcKR3B_0XkekgX`
};
export default ___CSS_LOADER_EXPORT___;
